import { SideMenuServiceService } from "./../services/side-menu-service.service";
import { Component, OnInit } from "@angular/core";
import { AuthService } from "../services/auth.service";

@Component({
  selector: "app-sidemenu",
  templateUrl: "./sidemenu.component.html",
  styleUrls: ["./sidemenu.component.scss"],
})
export class SidemenuComponent implements OnInit {
  constructor(
    private authService: AuthService,
    private sideMenuService: SideMenuServiceService
  ) {}

  ngOnInit() {
    if (
      this.authService.isQaDataEntry() ||
      this.authService.isQaAudit() ||
      this.authService.isQaManager()
    )
      return;
    this.updateSideMenu();
  }

  updateSideMenu() {
    this.sideMenuService.getUnDoneOrdersCount();
    this.sideMenuService.getReminderedOrdersCount();
  }
}
